import { createWebPushDriver } from '@agentic-flow-studio/shared/lib/push-driver';

export const pushDriver = createWebPushDriver('job-plan-portal');
